import { FCWithChildren } from '@types';
import React, { useMemo } from 'react';
import className from 'classnames';

import useLayoutContext from '@hooks/useLayoutContext';

type StudentGreetingProps = {
  studentName: string;
};

const StudentGreeting: FCWithChildren<StudentGreetingProps> = ({ studentName }) => {
  const name = useMemo(() => (studentName === 'Not Provided' ? '' : studentName), [studentName]);

  const containerCls = className(
    'md:absolute left-0 right-0 ml-auto mr-auto md:left-0 lg:left-0 xl:left-0 md:mt-32 md:pl-4 sm:pl-6 lg:pl-40 xl:pl-40',
  );

  const spansContCls = className('flex w-full justify-center md:sr-only pt-2');

  const spanCls = className('justify-center flex gap-2 text-2xl w-full items-center');

  return (
    <div className={containerCls}>
      <div className={spansContCls}>
        {!!name && (
          <h1 className={spanCls}>
            <span>Welcome</span>
            <span className="max-w-full truncate">{name}</span>
          </h1>
        )}
      </div>
    </div>
  );
};

export default StudentGreeting;
